export const keyCodes = {
  ArrowDown: "ArrowDown",
  ArrowUp: "ArrowUp",
  Enter: "Enter",
  Space: " ",
  Escape: "Escape",
};
